<div class="page-wrapper">
  <div class="page-header d-print-none">
    <div class="container-xl">
      <div class="row g-2 align-items-center">
        <div class="col">
          <div class="page-pretitle">Gestión</div>
          <h2 class="page-title">Envío de Notificaciones</h2>
        </div>
      </div>
    </div>
  </div>
  <div class="page-body">
    <div class="container-xl">
      @if (isLoading) {
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
              <p class="mt-2">Cargando datos...</p>
            </div>
          </div>
        </div>
      </div>
      } @else {
      <!-- Modal de selección de fondo -->
      <div class="modal" id="fundSelectionModal" tabindex="-1">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title text-primary-blue">Seleccionar Fondo</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              @if (isLoadingFunds) {
              <div class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Cargando fondos...</span>
                </div>
                <p class="mt-2">Cargando fondos...</p>
              </div>
              } @else {
              <div class="row">
                @for (fund of funds; track fund.idFund) {
                <div class="col-md-6 mb-3">
                  <div
                    class="card cursor-pointer"
                    (click)="onFundSelected(fund)"
                  >
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <div class="flex-fill">
                          <h4 class="card-title mb-1">{{ fund.name }}</h4>
                          <p class="text-muted mb-0">ID: {{ fund.idFund }}</p>
                          <p class="text-muted mb-0">{{ fund.description }}</p>
                        </div>
                        <div class="ms-3">
                          <span class="badge bg-green-lt">Activo</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
              }
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-link link-secondary"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabla de Jobs (últimos 5) -->
      @if (showJobsTable) {
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Últimos 5 Envíos de Notificaciones</h3>
              <div class="card-actions">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#fundSelectionModal"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-plus me-2"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 5l0 14"></path>
                    <path d="M5 12l14 0"></path>
                  </svg>
                  Enviar Nueva Notificación
                </button>
              </div>
            </div>
            <div class="table-responsive">
              <table
                class="table card-table table-vcenter text-nowrap datatable w-100"
              >
                <thead>
                  <tr>
                    <th class="text-center">Job ID</th>
                    <th class="text-center">Estado</th>
                    <th class="text-center">Total Usuarios</th>
                    <th class="text-center">Exitosos</th>
                    <th class="text-center">Fallidos</th>
                    <th class="text-center">Tipo</th>
                    <th class="text-center">Asunto</th>
                    <th class="text-center">Creado</th>
                    <th class="text-center">Completado</th>
                  </tr>
                </thead>
                <tbody>
                  @if (isLoadingJobs) {
                  <tr>
                    <td colspan="8" class="text-center py-4">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Cargando jobs...</span>
                      </div>
                      <p class="mt-2">Cargando jobs...</p>
                    </td>
                  </tr>
                  } @else { @for (job of paginatedJobs; track job.jobId) {
                  <tr>
                    <td class="text-center">{{ job.jobId }}</td>
                    <td class="text-center">
                      <span
                        class="badge"
                        [class.bg-green-lt]="job.status === 'completed'"
                        [class.bg-yellow-lt]="job.status === 'pending'"
                        [class.bg-red-lt]="job.status === 'failed'"
                      >
                        {{ job.status }}
                      </span>
                    </td>
                    <td class="text-center">{{ job.totalUsers }}</td>
                    <td class="text-center">{{ job.successCount }}</td>
                    <td class="text-center">{{ job.failedCount }}</td>
                    <td class="text-center">{{ job.type }}</td>
                    <td class="text-center">{{ job.subject }}</td>
                    <td class="text-center">
                      {{ job.createdAt | date : "short" }}
                    </td>
                    <td class="text-center">
                      {{ job.completedAt | date : "short" }}
                    </td>
                  </tr>
                  } }
                </tbody>
              </table>
            </div>

            <!-- Paginación para Jobs -->
            @if (jobsTotalPages > 1) {
            <div class="d-flex justify-content-center mt-3">
              <nav aria-label="Paginación de jobs">
                <ul class="pagination">
                  <li
                    class="page-item"
                    [class.disabled]="currentJobsPage === 1"
                  >
                    <button
                      class="page-link"
                      (click)="onJobsPageChange(currentJobsPage - 1)"
                      [disabled]="currentJobsPage === 1"
                    >
                      Anterior
                    </button>
                  </li>
                  @for (page of jobsPages; track page) {
                  <li
                    class="page-item"
                    [class.active]="currentJobsPage === page"
                  >
                    <button
                      class="page-link"
                      (click)="onJobsPageChange(page)"
                    >
                      {{ page }}
                    </button>
                  </li>
                  }
                  <li
                    class="page-item"
                    [class.disabled]="currentJobsPage === jobsTotalPages"
                  >
                    <button
                      class="page-link"
                      (click)="onJobsPageChange(currentJobsPage + 1)"
                      [disabled]="currentJobsPage === jobsTotalPages"
                    >
                      Siguiente
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
            }
          </div>
        </div>
      </div>
      }

      <!-- Estado del job de Estado de Cuenta en curso -->
      @if (activeJobStatus) {
      <div class="row mb-3">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Estado del Envío de Estado de Cuenta — Job #{{ activeJobStatus.jobId }}</h3>
              @if (!isPolling) {
              <div class="card-actions">
                <button type="button" class="btn btn-ghost-secondary btn-sm" (click)="dismissActiveJob()">
                  Cerrar
                </button>
              </div>
              }
            </div>
            <div class="card-body">
              @if (activeJobStatus.status === 'pending') {
              <div class="d-flex align-items-center gap-2">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                <span>En cola...</span>
              </div>
              } @else if (activeJobStatus.status === 'processing') {
              <div class="d-flex align-items-center gap-2">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                <span>Enviando... ({{ activeJobStatus.successCount }}/{{ activeJobStatus.totalUsers }})</span>
              </div>
              } @else if (activeJobStatus.status === 'completed') {
              <div class="row">
                <div class="col-auto">
                  <span class="badge bg-green-lt me-2">Completado</span>
                </div>
                <div class="col-auto">
                  <strong>Enviados:</strong> {{ activeJobStatus.successCount }}
                </div>
                <div class="col-auto">
                  <strong>Fallidos:</strong> {{ activeJobStatus.failedCount }}
                </div>
              </div>
              @if (activeJobStatus.result?.failed?.length) {
              <div class="mt-2">
                <small class="text-muted">Fallidos:</small>
                <ul class="mb-0">
                  @for (f of activeJobStatus.result!.failed; track f.nombre + '-' + f.cuenta) {
                  <li><small>{{ f.nombre }} — Cuenta: {{ f.cuenta || '—' }}: {{ f.reason }}</small></li>
                  }
                </ul>
              </div>
              }
              } @else if (activeJobStatus.status === 'failed') {
              <div class="alert alert-danger mb-0">
                <strong>Error:</strong> {{ activeJobStatus.error }}
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      }

      <!-- Tabla de Participantes del Fondo Seleccionado -->
      @if (showParticipantsTable && selectedFund) {
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">
                Participantes del Fondo: {{ selectedFund.name }}
              </h3>
              <div class="card-actions">
                <button
                  type="button"
                  class="btn btn-secondary me-2"
                  (click)="goBack()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-left me-2"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M5 12l14 0" />
                    <path d="M5 12l6 6" />
                    <path d="M5 12l6 -6" />
                  </svg>
                  Volver
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#sendNotificationModal"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-send me-2"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M10 14l11 -11" />
                    <path
                      d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5"
                    />
                  </svg>
                  Enviar Notificación
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-md-6">
                  <button
                    type="button"
                    class="btn btn-success me-2"
                    (click)="selectAllParticipants()"
                  >
                    Seleccionar Todos
                  </button>
                  <button
                    type="button"
                    class="btn btn-warning"
                    (click)="deselectAllParticipants()"
                  >
                    Deseleccionar Todos
                  </button>
                </div>
                <div class="col-md-6 text-end">
                  <span class="text-muted">
                    {{ selectedParticipantsSet.size }} de
                    {{ filteredParticipants.length }} seleccionados
                  </span>
                </div>
              </div>

              <!-- Buscador -->
              <div class="row mb-3">
                <div class="col-md-6">
                  <div class="input-group">
                    <span class="input-group-text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="icon icon-tabler icons-tabler-outline icon-tabler-search"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                        <path d="M21 21l-6 -6" />
                      </svg>
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Buscar por código, nombre, identificación o email..."
                      [(ngModel)]="searchTerm"
                      (input)="onSearchChange()"
                    />
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table
                  class="table card-table table-vcenter text-nowrap datatable w-100"
                >
                  <thead>
                    <tr>
                      <th class="text-center">Seleccionar</th>
                      <th class="text-center">Código Usuario</th>
                      <th class="text-center">Cuenta</th>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Identificación</th>
                      <th class="text-center">Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    @if (isLoadingParticipants) {
                    <tr>
                      <td colspan="4" class="text-center py-4">
                        <div class="spinner-border text-primary" role="status">
                          <span class="visually-hidden"
                            >Cargando participantes...</span
                          >
                        </div>
                        <p class="mt-2">Cargando participantes...</p>
                      </td>
                    </tr>
                    } @else { @for (participant of paginatedParticipants; track
                    participant.cuenta) {
                    <tr>
                      <td class="text-center">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          [checked]="isParticipantSelected(participant.identification)"
                          (change)="
                            onParticipantSelected(
                              participant.identification,
                              $any($event.target).checked
                            )
                          "
                        />
                      </td>
                      <td class="text-center">{{ participant.codUsuario }}</td>
                      <td class="text-center">{{ participant.cuenta }}</td>
                      <td class="text-center">{{ participant.name }}</td>
                      <td class="text-center">
                        {{ participant.identification }}
                      </td>
                      <td class="text-center">{{ participant.email }}</td>
                    </tr>
                    } }
                  </tbody>
                </table>
              </div>

              <!-- Paginación -->
              @if (totalPages > 1) {
              <div class="d-flex justify-content-center mt-3">
                <nav aria-label="Paginación de participantes">
                  <ul class="pagination">
                    <li class="page-item" [class.disabled]="currentPage === 1">
                      <button
                        class="page-link"
                        (click)="onPageChange(currentPage - 1)"
                        [disabled]="currentPage === 1"
                      >
                        Anterior
                      </button>
                    </li>
                    @for (page of participantPages; track page) {
                    <li
                      class="page-item"
                      [class.active]="currentPage === page"
                    >
                      <button
                        class="page-link"
                        (click)="onPageChange(page)"
                      >
                        {{ page }}
                      </button>
                    </li>
                    }
                    <li
                      class="page-item"
                      [class.disabled]="currentPage === totalPages"
                    >
                      <button
                        class="page-link"
                        (click)="onPageChange(currentPage + 1)"
                        [disabled]="currentPage === totalPages"
                      >
                        Siguiente
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      }

      <!-- Modal de Envío de Notificación -->
      <div class="modal" id="sendNotificationModal" tabindex="-1">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title text-primary-blue">Enviar Notificación</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label text-secondary-yellow"
                    >Tipo de Receptor</label
                  >
                  <select class="form-select" [(ngModel)]="receiverType" (ngModelChange)="onReceiverTypeChange()">
                    <option value="App">App</option>
                    <option value="Email">Email</option>
                    <option value="SMS">SMS</option>
                    <option value="EstadoCuenta">Estado de Cuenta</option>
                  </select>
                </div>
              </div>
              @if (receiverType !== 'EstadoCuenta') {
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label text-secondary-yellow"
                    >Mensaje</label
                  >
                  <select
                    class="form-select"
                    [(ngModel)]="selectedNotification"
                  >
                    <option value="">Seleccionar notificación</option>
                    @for (notification of activeNotifications; track
                    notification.secuencia) {
                    <option [ngValue]="notification">
                      {{ notification.mensaje }}
                    </option>
                    }
                  </select>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label text-secondary-yellow">Asunto</label>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="subject"
                    placeholder="Ingrese el asunto de la notificación"
                  />
                </div>
              </div>
              @if (receiverType === 'Email') {
              <div class="row">
                <div class="col-12 mb-2">
                  <label class="form-label text-secondary-yellow">Archivos adjuntos</label>
                  <input
                    type="file"
                    class="form-control"
                    multiple
                    (change)="onFilesSelected($event)"
                  />
                  <small class="form-hint">Máximo 10 archivos, 10 MB por archivo</small>
                </div>
              </div>
              @if (fileValidationError) {
              <div class="row mb-2">
                <div class="col-12">
                  <div class="alert alert-danger py-2 mb-0">{{ fileValidationError }}</div>
                </div>
              </div>
              }
              @if (selectedFiles.length > 0) {
              <div class="row mb-3">
                <div class="col-12">
                  <div class="list-group">
                    @for (file of selectedFiles; track $index) {
                    <div class="list-group-item d-flex justify-content-between align-items-center py-2">
                      <div class="d-flex align-items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="icon icon-tabler icons-tabler-outline icon-tabler-paperclip text-muted"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3l6.5 -6.5a3 3 0 0 0 -6 -6l-6.5 6.5a4.5 4.5 0 0 0 9 9l6.5 -6.5" />
                        </svg>
                        <span class="text-truncate" style="max-width: 260px;">{{ file.name }}</span>
                        <small class="text-muted">{{ formatFileSize(file.size) }}</small>
                      </div>
                      <button
                        type="button"
                        class="btn btn-ghost-danger btn-sm"
                        (click)="removeFile($index)"
                        title="Eliminar archivo"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="icon icon-tabler icons-tabler-outline icon-tabler-x"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M18 6l-12 12" />
                          <path d="M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                    }
                  </div>
                </div>
              </div>
              }
              }
              } @else {
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label text-secondary-yellow">Mes</label>
                  <select class="form-select" [(ngModel)]="month">
                    @for (m of months; track m.value) {
                    <option [ngValue]="m.value">{{ m.label }}</option>
                    }
                  </select>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label text-secondary-yellow">Año</label>
                  <input
                    type="number"
                    class="form-control"
                    [(ngModel)]="year"
                    [min]="2020"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3">
                  <label class="form-label text-secondary-yellow">Asunto</label>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="subject"
                    placeholder="Ej: Estado de cuenta - Abril 2026"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="alert alert-warning">
                    El envío puede tardar varios minutos según el número de destinatarios.
                  </div>
                </div>
              </div>
              }
              <div class="row">
                <div class="col-12">
                  <div class="alert alert-info">
                    <h4 class="alert-title">Resumen del Envío</h4>
                    <p><strong>Fondo:</strong> {{ selectedFund?.name }}</p>
                    <p>
                      <strong>Participantes seleccionados:</strong>
                      {{ selectedParticipantsSet.size }}
                    </p>
                    @if (receiverType !== 'EstadoCuenta') {
                    <p>
                      <strong>Notificación:</strong>
                      {{ selectedNotification?.mensaje || "No seleccionada" }}
                    </p>
                    } @else {
                    <p>
                      <strong>Período:</strong>
                      {{ monthName }} {{ year }}
                    </p>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-link link-secondary"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-primary"
                (click)="openSendNotificationModal()"
                [disabled]="isSendingNotification"
              >
                @if (isSendingNotification) {
                <span
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                ></span>
                Enviando... } @else {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-send me-2"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M10 14l11 -11" />
                  <path
                    d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5"
                  />
                </svg>
                Enviar Notificación }
              </button>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
